// Deterministic vivid color from string with good contrast
// 1) Hash the string -> hue [0, 360)
// 2) Use high saturation and mid-lightness; adjust lightness for readability

export function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Keep 32-bit
  }
  const hue = Math.abs(hash) % 360;
  const saturation = 85; // vivid
  let lightness = 55; // base
  // Push very cold hues slightly darker for contrast
  if (hue >= 180 && hue <= 260) lightness = 60;
  return `hsl(${hue} ${saturation}% ${lightness}%)`;
}

function hslToRgb(h, s, l) {
  // h in [0,360), s,l in [0,1]
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const hp = h / 60;
  const x = c * (1 - Math.abs((hp % 2) - 1));
  let r1 = 0, g1 = 0, b1 = 0;
  if (hp >= 0 && hp < 1) [r1, g1, b1] = [c, x, 0];
  else if (hp >= 1 && hp < 2) [r1, g1, b1] = [x, c, 0];
  else if (hp >= 2 && hp < 3) [r1, g1, b1] = [0, c, x];
  else if (hp >= 3 && hp < 4) [r1, g1, b1] = [0, x, c];
  else if (hp >= 4 && hp < 5) [r1, g1, b1] = [x, 0, c];
  else if (hp >= 5 && hp < 6) [r1, g1, b1] = [c, 0, x];
  const m = l - c / 2;
  const r = Math.round((r1 + m) * 255);
  const g = Math.round((g1 + m) * 255);
  const b = Math.round((b1 + m) * 255);
  return { r, g, b };
}

function relativeLuminance({ r, g, b }) {
  const srgb = [r, g, b].map((v) => v / 255).map((v) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)));
  const [R, G, B] = srgb;
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

export function readableTextColor(bg) {
  // Choose black or white by WCAG contrast against background color (provided as hsl string)
  const m = /hsl\((\d+)\s+(\d+)%\s+(\d+)%\)/i.exec(bg);
  if (m) {
    const h = parseInt(m[1], 10);
    const s = parseInt(m[2], 10) / 100;
    const l = parseInt(m[3], 10) / 100;
    const rgb = hslToRgb(h, s, l);
    const Lbg = relativeLuminance(rgb);
    const contrastBlack = (Lbg + 0.05) / 0.05; // Lblack = 0
    const contrastWhite = (1.05) / (Lbg + 0.05); // Lwhite = 1
    return contrastBlack >= contrastWhite ? '#000000' : '#ffffff';
  }
  return '#000000';
}


